import { action, observable } from "mobx";
import { PROPERTY_PURPOSE, PROPERTY_TYPE } from "properties/_models/PropertyMdl";

class HomeSearchStore {
    @observable purpose: PROPERTY_PURPOSE = PROPERTY_PURPOSE.BUY;
    @observable propertyType: PROPERTY_TYPE | undefined = undefined;

    @action setPurpose = (purpose: PROPERTY_PURPOSE) => {
        this.purpose = purpose;
        // Les types filtrables diffèrent selon louer/vendre → on réinitialise la sélection.
        this.propertyType = undefined;
    };

    @action setPropertyType = (propertyType: PROPERTY_TYPE | undefined) => {
        this.propertyType = propertyType;
    };
}

export const homeSearchStore = new HomeSearchStore();
